export function reset(view) {
	view._col_groups = [];
	view._col_groups_max_level = -1;
	view._row_groups = [];
	view._row_groups_max_level = -1;
}

export function getGroups(view, type) {
	return type === "row" ? view._row_groups : view._col_groups;
}

export function setGroups(view, type, groups) {
	const key = type === "row" ? "_row_groups" : "_col_groups";

	let max = -1;
	for (let i = 0; i < groups.length; i++)
		if (groups[i].level > max) max = groups[i].level;

	view[key] = groups;
	view[key + "_max_level"] = max;
}

export function getHiddenHash(view, type) {
	return type === "row" ? view._hidden_rows_hash : view._hidden_cols_hash;
}
